<script setup lang="ts">
const props = defineProps<{ name: string }>()
</script>
<template>
  <details class="rounded-lg border border-gray-200 bg-white p-3 shadow-sm hover:bg-gray-100">
    <summary class="flex w-full flex-nowrap text-xl font-bold">
      <slot name="summary">{{ props.name }}</slot>
    </summary>
    <div class="flex w-full flex-col gap-2 overflow-y-auto p-2">
      <slot></slot>
    </div>
  </details>
</template>
